import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  Journey,
  JourneyBasic,
  JourneyCompound,
  JourneyCountry,
  JourneyFilters,
  JourneyLight,
  JourneyPartial,
  JourneySorting,
  JourneyStandard
} from '../../lib/types/models/product/journey'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type JourneyVersionMap = {
  FULL: Journey
  LIGHT: JourneyLight
  COUNTRY: JourneyCountry
  PARTIAL: JourneyPartial
  BASIC: JourneyBasic
  STANDARD: JourneyStandard
  COMPOUND: JourneyCompound
}

export function getJourneys<T extends keyof JourneyVersionMap = 'FULL'>(
  input: PaginationRequest<JourneyFilters, string, T, JourneySorting> = {} as PaginationRequest<
    JourneyFilters,
    string,
    T
  >
) {
  if (!input.sort) input.sort = { reference: 'asc' }
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.products.getAllJourneys.url, null), input))
    .get<PaginationResponse<JourneyVersionMap[T]>>()
}
